import { Outlet } from 'react-router';

import { type UserProfileType } from '@/api/user';
import { InstanceNavigate } from '@/components/routing';
import { useMe } from '@/providers/User';

import { ROUTES } from './routes';

type Role = 'admin' | 'c99Superuser';

type Props = {
  role: Role;
};

const isAuthorized = (user: UserProfileType | undefined, role: Role) => {
  if (user) {
    if (user?.isC99Superuser) {
      return true;
    }
    if (role === 'admin' && user.isAdmin) {
      return true;
    }
    if (role === 'c99Superuser' && user.isC99Superuser) {
      return true;
    }
  }

  return false;
};

const UserRoleRoute = ({ role }: Props) => {
  const user = useMe();

  return isAuthorized(user, role) ? (
    <Outlet />
  ) : (
    <InstanceNavigate to={ROUTES.instance.path} replace />
  );
};

export default UserRoleRoute;
